module.exports = __webpack_public_path__ + "795a31029d943b9669b16bb9ce4c72ce.svg";